var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasterCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 38,
    viewBox: "0 0 53 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2373 26.8065H21.7812V11.7344H30.2373V26.8065Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3202 19.2699C22.3202 16.2125 23.7636 13.489 26.0113 11.7339C24.3676 10.4504 22.2932 9.68441 20.0387 9.68441C14.7015 9.68441 10.375 13.9759 10.375 19.2699C10.375 24.564 14.7015 28.8555 20.0387 28.8555C22.2932 28.8555 24.3676 28.0894 26.0113 26.806C23.7636 25.0509 22.3202 22.3274 22.3202 19.2699Z",
    fill: "#FE4949"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6369 19.2699C41.6369 24.564 37.3105 28.8555 31.9732 28.8555C29.7187 28.8555 27.6443 28.0894 26 26.806C28.2483 25.0509 29.6917 22.3274 29.6917 19.2699C29.6917 16.2125 28.2483 13.489 26 11.7339C27.6443 10.4504 29.7187 9.68441 31.9732 9.68441C37.3105 9.68441 41.6369 13.9759 41.6369 19.2699Z",
    fill: "#FFDA79"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.804688,
    width: 51.983,
    height: 36.3893,
    rx: 7.5,
    stroke: "#D4E1F2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardIcon);
export default __webpack_public_path__ + "static/media/master-card-icon.b8ac413b8c0bae81b0d93e8dedc31944.svg";
export { ForwardRef as ReactComponent };